<template>
  <main
    class="modal-wrapper self-report-modal"
    :class="{ 'self-report-modal--groups': selfReportType === 'group' }"
  >
    <transition name="slide-bottom">
      <div class="modal" v-if="showModal && selfReportType">
        <header>
          <h1>ИЗБЕРИ ОБЕКТА, ПО КОЙТО СИ РАБОТИЛ</h1>
          <span class="mck modal-close" @click="close(false)">F</span>
        </header>

        <section class="modal-content" v-if="selfReportType">
          <template v-if="selfReport.company._id">
            <TheInput
              type="datepicker"
              icon="D"
              placeholder="ДАТА"
              :disabledDates="{ from: new Date() }"
              v-model="selfReport.date"
              @update:modelValue="$set(selfReport, 'date', $event)"
            />
            <div
              class="company-project"
              v-if="selfReportType === 'group'"
              @click="isAddUsersModalOpened = true"
            >
              <span>Избвери</span>
              <p>
                <strong>Работници и групи</strong>
              </p>
            </div>
            <div class="company-project">
              <span>{{ selfReport.company.companyName }}</span>
              <p>
                <strong>{{ selfReport.project.projectName }}</strong>
              </p>
            </div>
          </template>
          <CompaniesTree
            v-else
            :showActiveProjects="true"
            :justSelecting="true"
            @selected="selectCompanyProject($event)"
          />

          <div v-if="selfReport.company._id" class="report-content">
            <template v-if="selfReportType === 'group'">
              <section v-for="w of selfReport.workers" :key="w._id">
                <p>
                  БЕЛЕЖКА ЗА <strong>{{ w.name }}</strong>
                </p>

                <div class="input-wrapper">
                  <textarea
                    placeholder="Попълни тук..."
                    rows="8"
                    v-model="w.tasks[0].name"
                  ></textarea>
                </div>
              </section>
            </template>
            <template v-else>
              <h1>НАПИШИ КРАТКА БЕЛЕЖКА КАКВО СИ РАБОТИЛ</h1>
              <div class="input-wrapper">
                <textarea
                  placeholder="Попълни тук..."
                  rows="8"
                  v-model="selfReport.workers[0].tasks[0].name"
                ></textarea>
              </div>
            </template>
          </div>
        </section>

        <button
          v-if="selfReportType"
          class="btn btn-new"
          :disabled="isSaveDisabled"
          @click="save()"
        >
          <strong>ЗАПИШИ ОТЧЕТА</strong>
        </button>
      </div>
    </transition>

    <transition name="fade">
      <AddUsersModal
        v-if="isAddUsersModalOpened"
        :incomingUsers="selfReport.workers"
        :date="selfReport.date"
        :usersRole="tabValues.reports.SELF_REPORTS"
        :ignoreUser="getUser._id"
        :getUserGroups="getUser._id"
        @saveAddUsersModal="saveAddUsersModal"
        @close="isAddUsersModalOpened = false"
      />
    </transition>

    <TheFixedDropdown
      v-if="!selfReportType"
      label="ДЕЙСТВИЯ"
      :arr="['Собствен самоотчет', 'Самоотчет на работници и групи']"
      @selected="selectSelfReportType($event)"
      @close="close(false)"
    />
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import CompaniesTree from "./CompaniesTree.vue";
import TheInput from "@/components/TheInput";
import TheFixedDropdown from "@/components/TheFixedDropdown";
import AddUsersModal from "@/components/shared/AddUsersModal.vue";
import log from "../mixins/log.js";
import tabValues from "../../data/tabValues";
import { getAccess } from "../mixins/getAccess";
export default {
  components: { CompaniesTree, TheFixedDropdown, TheInput, AddUsersModal },
  mixins: [log],
  computed: {
    ...mapGetters(["getUser"]),
    isSaveDisabled() {
      if (this.selfReport.company._id) {
        return this.selfReport.workers.some((w) => !w.tasks[0].name);
      }
      return true;
    },
  },
  data() {
    return {
      tabValues,
      showModal: false,
      isAddUsersModalOpened: false,
      selfReportType: "",
      selfReport: {
        date: new Date(),
        company: {},
        project: {},
        createdBy: {},
        isVisible: true,
        isSelfReport: true,
      },
    };
  },
  methods: {
    selectSelfReportType(value) {
      this.selfReportType = value === "Собствен самоотчет" ? "self" : "group";
    },
    selectCompanyProject(c) {
      let copyUser = { ...this.getUser };
      delete copyUser.roles;

      let worker = {
        ...copyUser,
        startHour: "08:00",
        endHour: "17:00",
        part: "",
        tasks: [{ startHour: "08:00", endHour: "17:00" }],
      };
      let workers = [];
      if (this.selfReportType === "self") workers = [worker];

      this.$set(this.selfReport, "workers", workers);
      this.selfReport.createdBy._id = copyUser._id;
      this.selfReport.createdBy.name = copyUser.name;
      this.selfReport.company._id = c.company;
      this.selfReport.company.companyName = c.companyName;
      this.selfReport.project._id = c.project;
      this.selfReport.project.projectName = c.projectName;
    },
    saveAddUsersModal(workers) {
      this.selfReport.workers = [];
      for (let w of workers) {
        this.selfReport.workers.push({
          ...w,
          startHour: "08:00",
          endHour: "17:00",
          part: "",
          tasks: [{ startHour: "08:00", endHour: "17:00" }],
        });
      }
      this.isAddUsersModalOpened = false;
    },
    close(updated) {
      this.$emit("close", updated);
    },
    async validateReport() {
      try {
        let url = `${process.env.VUE_APP_BASE_URI}/report/validate-report`;
        let res = await this.$http.post(url, this.selfReport);

        if (res.data && res.data.exists.length) {
          this.$snotify.success(`Вече сте се отчели за този обект днес`);
          return false;
        } else return true;
      } catch (err) {
        console.log(err);
      }
    },
    async save() {
      if (!(await this.validateReport())) return;
      try {
        let url = `${process.env.VUE_APP_BASE_URI}/report`;

        for (const worker of this.selfReport.workers) {
          let report = {
            ...this.selfReport,
            workers: [worker],
          };

          await this.$http.post(url, report);
        }

        this.$snotify.success("Вашият отчет беше създаден успешно!");
        this.newLog(
          "newReport",
          `проект - ${this.selfReport.project.projectName}`
        );
        this.close(true);
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    let canSelfReport = getAccess("self_reports", "reports") === "edit";
    let canSelfReportGroups =
      getAccess("self_reports_groups", "reports") === "edit";

    if (canSelfReport && !canSelfReportGroups) this.selfReportType = "self";

    if (canSelfReportGroups && !canSelfReport) this.selfReportType = "group";

    setTimeout(() => {
      this.showModal = true;
    }, 500);
  },
};
</script>

<style lang="scss">
.self-report-modal {
  align-items: flex-end;

  &.self-report-modal--groups {
    textarea {
      height: 30px;
    }
  }
  .modal {
    border-radius: 10px 10px 0 0;
    padding: 10px 10px 30px 10px;
    // text-align: center;
    justify-content: center;
    max-width: 500px;
    width: 100%;

    h1 {
      font-size: 16px;
      text-align: center;
      margin: 0 auto;
      max-width: 60%;
    }

    header {
      display: flex;
      justify-content: space-between;

      h1 {
        flex-grow: 2;
      }

      .modal-close {
        position: initial;
      }
    }

    .modal-content {
      gap: 10px;

      .report-content {
        p {
          font-size: 16px;
          text-align: center;
        }
      }

      .the-input {
        background: #d3e2fb;
        border: 3px solid #3b86ff;
      }

      .company-project {
        border: 3px solid #3b86ff;
        background: #d3e2fb;
        border-radius: 4px;
        cursor: pointer;
        text-align: left;
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 5px;

        p {
          font-size: 15px;
        }
      }
      textarea {
        border: 1px solid #cecece;
        margin-top: 10px;
        padding: 5px 10px;
        width: 100%;
      }
    }

    .btn-close {
      background: #b8ccdc;
      color: #000000;
      margin: initial;
    }
    .btn {
      font-size: 16px;
      width: calc(100% - 10px);
    }
  }
}
@media screen and (max-width: 1000px) {
  .self-report-modal {
    .modal {
      header {
        flex-direction: row;
      }

      h1 {
        text-align: initial;
        margin: initial;
        max-width: initial;
      }

      .modal-content {
        .companies-ul-wrapper {
          .company-li {
            .project-toggle-active {
              height: 50px;
            }
          }
        }
      }
    }
  }
}
</style>
